// removed by extract-text-webpack-plugin
module.exports = {"calc":"calc__1zXF6","ratio":"ratio__L7fKp","input":"input__11YsG","select":"select__3f3hY","inputWrapper":"inputWrapper__3z71Z","unit":"unit__1p58r"};


//////////////////
// WEBPACK FOOTER
// ./components/calc/style.css
// module id = Wh9W
// module chunks = 0